/** @format */

import persian from 'react-date-object/calendars/persian';
import persian_fa from 'react-date-object/locales/persian_fa';
import InputIcon from 'react-multi-date-picker/components/input_icon';
import PropTypes from 'prop-types';
import DatePicker from 'react-multi-date-picker';
import TimePicker from 'react-multi-date-picker/plugins/time_picker';
import moment from 'jalali-moment';

import 'react-multi-date-picker/styles/backgrounds/bg-dark.css';

const Datepicker = ({
	handleChange,
	value,
	name,
	defaultValue = false,
	minDate = null,
}) => {
	return (
		<>
			{/*defaultValue && (
				<span className='text-dark-mode f-14 text-center my-2'>{value}</span>
			)*/}
			<DatePicker
				render={<InputIcon />}
				zIndex='9999999999999'
				calendar={persian}
				locale={persian_fa}
				value={value}
				minDate={minDate === null ? new Date() : minDate}
				className=''
				name={name}
				portal
				format='YYYY/MM/DD'
				onChange={(e) => {
					handleChange(name, `${e.year}/${e.month}/${e.day}`, true);
				}}
			/>
		</>
	);
};

DatePicker.propTypes = {
	handleChange: PropTypes.func,
	value: PropTypes.any,
	name: PropTypes.string,
};

export default Datepicker;
